import { CellProps } from 'react-table'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { ProfissionalDeSaudeActionsCell } from './ProfissionalDeSaudeActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'
import { PessoaList } from 'app/modules/auth'
import { PlainHeader, sortableColumn, StackedCell, StatusDot, TableColumn } from 'app/components'

export const ProfissionalDeSaudeColumns = (
  t: TFunction
): ReadonlyArray<TableColumn<PessoaList>> => [
  // Nome com o documento (CPF, ou CNS na falta) como apoio; só o nome ordena.
  sortableColumn<PessoaList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.nome') },
      { field: 'pessoa.cpf', label: t('cols.documento'), sortable: false },
    ],
    Cell: ({ row }: CellProps<PessoaList>) => (
      <StackedCell
        primary={row.original.nomeSocial || row.original.nome}
        secondary={row.original.cpf || row.original.cns}
      />
    ),
  }),
  // Situação em texto + tom: a cor só reforça.
  {
    Header: () => <PlainHeader>Certificado digital</PlainHeader>,
    id: 'certificadoDigital',
    cellWidth: '180px',
    hideOnMobile: true,
    Cell: ({ row }: CellProps<PessoaList>) =>
      row.original.certificadoDigital ? (
        <StatusDot label='Informado' tone='success' />
      ) : (
        <StatusDot label='Pendente' tone='warning' />
      ),
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<PessoaList>) => (
      <ProfissionalDeSaudeActionsCell profissional={row.original} />
    ),
  },
]
